'use client';
import apiClient from './apiClient';

/** 會員相關 */
class UserClient {
    // 取得 user 成就
    getUserAchievement = () => apiClient.get('/member/achievement');

    // 取得追蹤名單
    getUserFollowing = ({ uid, isPure = false }) =>
        apiClient.get(`/member/following/${uid}?isPure=${isPure}`);

    // 封鎖、解封用戶
    toggleBlockUser = ({ blockUid }) => apiClient.post(`/member/block/${blockUid}`);
}

const userClient = new UserClient();

export default userClient;
